import React, { useState } from "react";
import "./HomePage.css";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import icon3 from "../../assets/images/collection-personal-information.png";
import icon4 from "../../assets/images/use-of-cookies.png";
import icon1 from "../../assets/images/collection-personal-information-white.png";
import icon2 from "../../assets/images/use-of-cookies-white.png";
import PrivacyStatement from "./Collection";
export default function MobilePrivacyPolicy() {
  const tabContent = [
    {
      title: "Collection and Use of Your Personal Information",
      icon: icon1,
      iconInactive: icon3,
      content: PrivacyStatement,
    },
    {
      title: "Use of Cookies",
      icon: icon2,
      iconInactive: icon4,
      content:
        "Lawnet uses &quot;cookies&quot; to help you personalise your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you and can only be read by a web server in the domain that issued the cookie to you. <br/> <br /> One of the primary purposes of cookies is to provide a convenience feature that saves your time. The purpose of a cookie is to tell the web server that you have returned to a specific page. For example, if you personalise Lawnet pages, or register with Lawnet site or services, a cookie helps Lawnet to recall your specific information on subsequent visits. This simplifies the process of recording your personal information, such as billing addresses, shipping addresses, and so forth. When you return to the same Lawnet website, the information you previously provided can be retrieved, allowing you to easily use the Lawnet features that you customised.<br/> <br />  You have the ability to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of the Lawnet services or websites you visit.",
    },
  ];
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <div className="" style={{ height: "20px" }}></div>

      <div className="privacy-policy-background">
        <div className="privacy-policy">
          <Box
            sx={{
              width: "100%",
              border: "1px solid #ccc",
              borderRadius: 2,
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="Tab component"
              textColor="inherit"
              indicatorColor="none"
              sx={{
                backgroundColor: "#f9f9f9",
                borderBottom: "1px solid #ccc",
                borderRadius: 2,
              }}
            >
              {tabContent.map((tab, index) => (
                <Tab
                  key={index}
                  label={tab.title}
                  icon={
                    <img
                      src={activeTab === index ? tab.icon : tab.iconInactive}
                      alt={`${tab.title} icon`}
                      style={{ width: 32, height: 32 }}
                    />
                  }
                  iconPosition="start"
                  sx={{
                    color: activeTab === index ? "white" : "#0089BE",
                    backgroundColor: activeTab === index ? "#0089BE" : "white",
                    borderRadius: 2,
                    maxWidth: "50%",
                    minWidth: "50%",
                    fontWeight: "600",
                    fontSize: "large",
                    textTransform: "none",
                    display: "flex", // Use flexbox for alignment
                    justifyContent: "flex-start", // Align both the icon and label to the left
                    textAlign: "left", // Align label text to the left
                    paddingLeft: 1, // Optional: add padding between icon and label
                  }}
                />
              ))}
            </Tabs>
            <Box
              sx={{
                padding: 2,
                backgroundColor: "rgba(249, 249, 249, 0.7)",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              {activeTab === 0 ? (
                <PrivacyStatement />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    color: "#00267B", // Blue text
                    textAlign: "justify", // Justified alignment
                  }}
                  dangerouslySetInnerHTML={{
                    __html: tabContent[activeTab].content,
                  }}
                />
              )}
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
}
